import { Injectable } from '@angular/core'
import { Functions, httpsCallable } from '@angular/fire/functions'

@Injectable({
    providedIn: 'root',
})
export class AdmytService {
    constructor(private functions: Functions) {}

    // Centres
    getCentres() {
        const getCentres = httpsCallable(this.functions, 'httpGetCentres')
        return getCentres({})
    }

    // Tenants
    getTenants(centreId: string, limit = 100, offset = 0, status = 'active') {
        const getTenants = httpsCallable(this.functions, 'httpGetTenants')
        console.log('getTenants', centreId, limit, offset, status)
        return getTenants({ centreId, limit, offset, status })
    }

    createTenant(centreId: string, name: string, baysNumber: number) {
        const createTenant = httpsCallable(this.functions, 'httpCreateTenant')
        return createTenant({ centreId, name, baysNumber })
    }

    getTenant(centreId: string, tenantId: string) {
        const getTenant = httpsCallable(this.functions, 'httpGetTenant')
        return getTenant({ centreId, tenantId })
    }

    updateTenant(centreId: string, tenantId: string, name: string, baysNumber: number) {
        const updateTenant = httpsCallable(this.functions, 'httpUpdateTenant')
        return updateTenant({ centreId, tenantId, name, baysNumber })
    }

    deactivateTenant(centreId: string, tenantId: string) {
        const deactivateTenant = httpsCallable(this.functions, 'httpDeactivateTenant')
        return deactivateTenant({ centreId, tenantId })
    }

    reactivateTenant(centreId: string, tenantId: string) {
        const reactivateTenant = httpsCallable(this.functions, 'httpReactivateTenant')
        return reactivateTenant({ centreId, tenantId })
    }

    // Tenant Users
    getTenantUsers(centreId: string, tenantId: string, limit = 100, offset = 0) {
        const getTenantUsers = httpsCallable(this.functions, 'httpGetTenantUsers')
        return getTenantUsers({ centreId, tenantId, limit, offset })
    }

    createTenantUser(
        centreId: string,
        tenantId: string,
        userData: {
            firstName: string
            lastName: string
            email: string
            agreements: { [key: string]: boolean }
            cars: Array<{ plate: string; make: string; model: string }>
        }
    ) {
        const createTenantUser = httpsCallable(this.functions, 'httpCreateTenantUser')
        return createTenantUser({ centreId, tenantId, ...userData })
    }

    getTenantUser(centreId: string, tenantId: string, userId: string) {
        const getTenantUser = httpsCallable(this.functions, 'httpGetTenantUser')
        return getTenantUser({ centreId, tenantId, userId })
    }

    deleteTenantUser(centreId: string, tenantId: string, userId: string) {
        const deleteTenantUser = httpsCallable(this.functions, 'httpDeleteTenantUser')
        return deleteTenantUser({ centreId, tenantId, userId })
    }

    createTenantUserByEmail(email: string, centreId: string, baysNumber: number) {
        const createTenantUserByEmail = httpsCallable(this.functions, 'httpCreateTenantUserByEmail')
        return createTenantUserByEmail({ email, centreId, baysNumber })
    }

    // User Cars
    getUserCars(userId: string) {
        const getUserCars = httpsCallable(this.functions, 'httpGetUserCars')
        return getUserCars({ userId })
    }

    createUserCar(userId: string, carData: { plate: string; make: string; model: string }) {
        const createUserCar = httpsCallable(this.functions, 'httpCreateUserCar')
        return createUserCar({ userId, ...carData })
    }

    deleteUserCar(userId: string, plate: string) {
        const deleteUserCar = httpsCallable(this.functions, 'httpDeleteUserCar')
        return deleteUserCar({ userId, plate })
    }

    // Users
    getUsers(status?: string, limit = 100, offset = 0) {
        const getUsers = httpsCallable(this.functions, 'httpGetUsers')
        return getUsers({ status, limit, offset })
    }

    // Bookings
    createBooking(bookingData: { spaceId: string; startTime: string; endTime: string; userId: string; vehicleId: string }) {
        const createBooking = httpsCallable(this.functions, 'httpCreateBooking')
        return createBooking(bookingData)
    }

    getBooking(bookingId: string) {
        const getBooking = httpsCallable(this.functions, 'httpGetBooking')
        return getBooking({ bookingId })
    }

    updateBooking(bookingId: string, bookingData: { spaceId?: string; startTime?: string; endTime?: string; userId?: string; vehicleId?: string }) {
        const updateBooking = httpsCallable(this.functions, 'httpUpdateBooking')
        return updateBooking({ bookingId, ...bookingData })
    }

    cancelBooking(bookingId: string) {
        const cancelBooking = httpsCallable(this.functions, 'httpCancelBooking')
        return cancelBooking({ bookingId })
    }

    // Parking Spaces
    getParkingSpaces() {
        const getParkingSpaces = httpsCallable(this.functions, 'httpGetParkingSpaces')
        return getParkingSpaces({})
    }

    getParkingSpace(spaceId: string) {
        const getParkingSpace = httpsCallable(this.functions, 'httpGetParkingSpace')
        return getParkingSpace({ spaceId })
    }

    // Availability
    checkAvailability(availabilityData: { spaceId: string; startTime: string; endTime: string }) {
        const checkAvailability = httpsCallable(this.functions, 'httpCheckAvailability')
        return checkAvailability(availabilityData)
    }

    // API Logs
    getApiLogs(options: { limit?: number; isError?: boolean; startDate?: string; endDate?: string; endpoint?: string } = {}) {
        const getApiLogs = httpsCallable(this.functions, 'httpGetAdmytApiLogs')
        return getApiLogs(options)
    }

    getApiLog(logId: string) {
        const getApiLog = httpsCallable(this.functions, 'httpGetAdmytApiLog')
        return getApiLog({ logId })
    }

    getApiErrorLogs(limit: number = 100) {
        const getApiErrorLogs = httpsCallable(this.functions, 'httpGetAdmytApiErrorLogs')
        return getApiErrorLogs({ limit })
    }

    resyncClientAdmyt(clientId: string) {
        const resync = httpsCallable(this.functions, 'httpResyncClientAdmyt')
        return resync({ clientId })
    }

    runAudit(centerId?: string) {
        const audit = httpsCallable(this.functions, 'httpAdmytAudit', { timeout: 540000 })
        return audit(centerId ? { centerId } : {})
    }
}
